@if (enableAutocomplete()) {
  <mat-form-field subscriptSizing="dynamic" class="location-search">
    <mat-icon matPrefix class="on-surface-text"> search </mat-icon>
    <input
      #locationInput
      matInput
      placeholder="Search a location"
      class="location-name-form-input"
      (input)="updateLocationName($event)"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      autoActiveFirstOption
      (optionSelected)="autocompleteOptionSelected($event)"
      [displayWith]="autocompleteDisplayFn"
    >
      @for (option of locationOptions(); track option) {
        <mat-option class="title-option" [value]="option">
          <span class="body-medium">{{
            option.placePrediction?.mainText?.text?.slice(
              0,
              option.placePrediction?.mainText?.matches?.[0]?.startOffset ?? 0
            )
          }}</span>
          <span class="body-medium match">{{
            option.placePrediction?.mainText?.text?.slice(
              option.placePrediction?.mainText?.matches?.[0]?.startOffset ?? 0,
              option.placePrediction?.mainText?.matches?.[0]?.endOffset ?? 0
            )
          }}</span>
          <span class="body-medium">{{
            option.placePrediction?.mainText?.text?.slice(
              option.placePrediction?.mainText?.matches?.[0]?.endOffset ?? 0
            )
          }}</span>
          <span class="label-small on-surface-variant-text">
            {{ option.placePrediction?.secondaryText?.text }}
          </span>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
}

<div
  class="wrapper"
  [style.height]="height() ? height() + 'px' : '100%'"
  [class.collapsed]="collapsed()"
>
  <mat-spinner [diameter]="36"></mat-spinner>
  <google-map
    #map
    width="100%"
    height="100%"
    [options]="mapOptions"
    (mapClick)="setSelectionMarkerFromClick($event)"
  >
    @if (selectionMarkerCoords()) {
      <map-advanced-marker
        [position]="selectionMarkerCoords() ?? DEFAULT_LAT_LNG"
        [zIndex]="10"
      />
    }
    @if (this.enableUserLocation() && userMarkerCoords()) {
      <map-advanced-marker
        [position]="userMarkerCoords() ?? DEFAULT_LAT_LNG"
        [content]="userMarkerImage"
      />
      <img
        #userMarkerImage
        width="20px"
        height="20px"
        src="./assets/user-location-dot.png"
      />
    }
  </google-map>
</div>
